var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 807,
    height: 719,
    viewBox: "0 0 807 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_1923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.281 121.999L142.238 616.807L636.985 772.678L792.028 277.87L297.281 121.999Z",
    fill: "#CDDEE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.405 719.242C474.725 721.458 472.408 723.106 469.765 723.964C465.622 725.435 460.216 725.744 453.869 724.95",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3636 485.648C68.2487 418.699 214.232 323.431 411.413 272.884C423.097 269.942 434.673 267.176 446.142 264.587",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M305.169 613.941C294.121 629.167 321.446 667.916 366.209 700.471C410.972 733.026 456.205 747.075 467.253 731.835L476.405 719.242C465.358 734.468 420.11 720.419 375.347 687.864C330.584 655.309 303.259 616.575 314.306 601.334L305.169 613.941Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.955 380.524C657.955 380.524 657.045 383.672 660.188 375.125C671.589 344.07 622.888 332.007 606.552 339.451C619.127 308.69 595.079 291.302 556.001 285.727C567.048 267.456 592.302 220.41 597.796 211.892C616.336 183.088 616.336 142.589 587.204 124.495C587.204 124.495 572.513 122.626 546.54 164.95L402.129 413.638C402.129 413.638 342.072 336.965 309.576 309.191C262.272 271.766 230.246 296.936 233.184 313.148C233.58 315.354 240.338 320.989 260.303 343.717C300.101 389.042 376.907 504.353 352.843 560.093L252.996 723.802L423.063 778.822C423.063 778.822 456.852 721.126 501.792 638.701C545.159 566.75 634.009 533.15 672.911 475.012C675.761 470.069 690.084 454.211 693.316 449.283C727.708 397.059 681.96 380.524 657.955 380.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M409.973 643.702C375.42 618.561 340.573 604.468 321.402 606.365L314.13 618.825C333.639 617.972 367.369 631.962 400.806 656.294C428.381 676.36 449.286 698.765 458.761 716.609L466.9 702.133C457.042 684.598 436.593 663.047 409.973 643.702Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.996 723.802L349.006 559.071C373.07 503.331 299.248 390.086 260.376 343.791C243.643 324.137 233.257 313.221 233.257 313.221C229.496 297.289 262.83 272.384 309.649 309.264C342.131 336.965 402.202 413.712 402.202 413.712L546.613 165.023C565.197 135.602 578.198 124.951 587.277 124.568C587.277 124.568 630.674 151.254 597.869 211.966C593.036 220.881 510.415 364.489 499.441 382.76C488.467 401.031 493.564 429.497 517.07 438.264C517.07 438.264 559.541 425.981 592.199 370.682C600.352 356.854 612.031 330.845 610.18 320.297C604.627 288.654 556.133 285.8 556.133 285.8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.099 413.653L421.094 440.869",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.955 380.524C685.985 380.613 723.153 401.12 696.43 443.517C660.29 500.889 630.424 505.303 630.424 505.303C609.651 497.947 600.278 463.979 613.632 445.149",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.983 475.086C633.098 532.459 545.173 566.823 501.864 638.774C456.998 721.156 423.136 778.896 423.136 778.896",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.463 719.301C487.511 704.075 460.186 665.327 415.423 632.771C370.66 600.216 325.427 586.167 314.379 601.408L305.227 614.015C316.289 598.774 361.522 612.823 406.285 645.379C451.048 677.934 478.373 716.682 467.326 731.908L476.463 719.301Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M421.108 440.868C412.294 421.744 437.268 353.25 437.268 353.25L402.216 413.565L421.108 440.868Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M579.461 291.302C572.028 288.566 563.639 285.565 556.103 285.712L503.216 378.303C503.216 378.303 558.953 335.288 579.461 291.302Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M625.062 336.892C618.804 336.891 612.575 337.752 606.552 339.451L602.512 349.911C594.549 371.492 561.098 410.888 561.098 410.888L554.561 424.334C589.819 411.564 616.894 360.032 625.062 336.892Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M657.955 380.524L640.781 405.195L610.709 448.371L608.006 458.507C640.326 444.885 662.7 407.46 668.429 381.436C664.916 381.478 661.408 381.172 657.955 380.524Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.564 497.123C516.232 503.684 495.175 509.765 473.393 515.365C276.198 565.911 102.478 552.613 85.3486 485.648",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.336 242.418C716.88 239.858 788.763 260.748 799.457 302.6C809.961 343.659 759.131 395.279 672.763 440.883",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.553 291.302C396.482 291.302 402.099 285.677 402.099 278.739C402.099 271.8 396.482 266.176 389.553 266.176C382.624 266.176 377.007 271.8 377.007 278.739C377.007 285.677 382.624 291.302 389.553 291.302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.107 558.349C243.036 558.349 248.653 552.724 248.653 545.786C248.653 538.847 243.036 533.223 236.107 533.223C229.178 533.223 223.561 538.847 223.561 545.786C223.561 552.724 229.178 558.349 236.107 558.349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.343 267.47C745.272 267.47 750.889 261.845 750.889 254.907C750.889 247.968 745.272 242.344 738.343 242.344C731.414 242.344 725.797 247.968 725.797 254.907C725.797 261.845 731.414 267.47 738.343 267.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.036 320.224C696.647 320.224 699.574 317.293 699.574 313.677C699.574 310.062 696.647 307.131 693.036 307.131C689.426 307.131 686.499 310.062 686.499 313.677C686.499 317.293 689.426 320.224 693.036 320.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.343 117.948C741.954 117.948 744.881 115.017 744.881 111.402C744.881 107.786 741.954 104.855 738.343 104.855C734.733 104.855 731.806 107.786 731.806 111.402C731.806 115.017 734.733 117.948 738.343 117.948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.086 178.058C446.697 178.058 449.624 175.127 449.624 171.511C449.624 167.896 446.697 164.965 443.086 164.965C439.476 164.965 436.549 167.896 436.549 171.511C436.549 175.127 439.476 178.058 443.086 178.058Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.063 124.495C268.673 124.495 271.6 121.564 271.6 117.949C271.6 114.333 268.673 111.402 265.063 111.402C261.452 111.402 258.525 114.333 258.525 117.949C258.525 121.564 261.452 124.495 265.063 124.495Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.398 248.758C113.008 248.758 115.935 245.827 115.935 242.211C115.935 238.596 113.008 235.665 109.398 235.665C105.787 235.665 102.86 238.596 102.86 242.211C102.86 245.827 105.787 248.758 109.398 248.758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.303 463.994C248.914 463.994 251.84 461.063 251.84 457.448C251.84 453.832 248.914 450.901 245.303 450.901C241.693 450.901 238.766 453.832 238.766 457.448C238.766 461.063 241.693 463.994 245.303 463.994Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.811 628.549C658.422 628.549 661.348 625.618 661.348 622.002C661.348 618.387 658.422 615.456 654.811 615.456C651.201 615.456 648.274 618.387 648.274 622.002C648.274 625.618 651.201 628.549 654.811 628.549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.753 683.332C539.954 683.332 540.928 682.357 540.928 681.155C540.928 679.952 539.954 678.978 538.753 678.978C537.553 678.978 536.579 679.952 536.579 681.155C536.579 682.357 537.553 683.332 538.753 683.332Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.243 663.561C233.443 663.561 234.417 662.586 234.417 661.383C234.417 660.181 233.443 659.206 232.243 659.206C231.042 659.206 230.068 660.181 230.068 661.383C230.068 662.586 231.042 663.561 232.243 663.561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.467 434.337C157.668 434.337 158.641 433.362 158.641 432.16C158.641 430.957 157.668 429.982 156.467 429.982C155.266 429.982 154.293 430.957 154.293 432.16C154.293 433.362 155.266 434.337 156.467 434.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.896 490.018C731.097 490.018 732.07 489.043 732.07 487.84C732.07 486.638 731.097 485.663 729.896 485.663C728.695 485.663 727.722 486.638 727.722 487.84C727.722 489.043 728.695 490.018 729.896 490.018Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.414 353.235C410.615 353.235 411.589 352.261 411.589 351.058C411.589 349.856 410.615 348.881 409.414 348.881C408.214 348.881 407.24 349.856 407.24 351.058C407.24 352.261 408.214 353.235 409.414 353.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.247 208.097C345.447 208.097 346.421 207.122 346.421 205.919C346.421 204.717 345.447 203.742 344.247 203.742C343.046 203.742 342.072 204.717 342.072 205.919C342.072 207.122 343.046 208.097 344.247 208.097Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.1 50.0869C373.301 50.0869 374.274 49.1121 374.274 47.9096C374.274 46.7072 373.301 45.7324 372.1 45.7324C370.899 45.7324 369.926 46.7072 369.926 47.9096C369.926 49.1121 370.899 50.0869 372.1 50.0869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.201 75.581C504.402 75.581 505.375 74.6062 505.375 73.4038C505.375 72.2013 504.402 71.2266 503.201 71.2266C502 71.2266 501.027 72.2013 501.027 73.4038C501.027 74.6062 502 75.581 503.201 75.581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.173 200.138C661.374 200.138 662.348 199.163 662.348 197.96C662.348 196.758 661.374 195.783 660.173 195.783C658.973 195.783 657.999 196.758 657.999 197.96C657.999 199.163 658.973 200.138 660.173 200.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.873 300.379C624.074 300.379 625.048 299.404 625.048 298.202C625.048 296.999 624.074 296.024 622.873 296.024C621.673 296.024 620.699 296.999 620.699 298.202C620.699 299.404 621.673 300.379 622.873 300.379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.153 406.945C544.453 429.968 550.755 464.803 574.319 473.571C574.319 473.571 605.288 473.571 657.954 380.524C673.776 352.574 637.71 339.451 637.71 339.451C627.626 335.904 616.635 335.904 606.551 339.451",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.168 613.941C301.731 618.664 302.01 625.71 305.345 634.022",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.601 619.001C312.467 615.884 311.881 612.594 311.867 609.277",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_1923"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 807,
    height: 719,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/Hand.1c795f6213a4e37dcaf4b78004f3bddd.svg";
export { ForwardRef as ReactComponent };